export enum FilterName {
  Tags = 'tags',
  Status = 'status',
  Attributes = 'attributes',
  Type = 'type'
}
